// extracted by css-extract-rspack-plugin
export default {"cls1":"after_click_map-cls1_H_L","cls2":"after_click_map-cls2_yPy after_click_map-cls1_H_L"};